// extracted by mini-css-extract-plugin
export default {"navs_box":"Web_navs_box__9qAYG","logo":"Web_logo__a7RfS","navs_title":"Web_navs_title__CJE5S","nav_item":"Web_nav_item__JMgVg","active":"Web_active__0xeY4"};